var _rect, _path, _path2, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentMc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3765 5.43921H14.7926V14.5593H20.3765V5.43921Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3678 9.9999C15.3671 9.12171 15.5662 8.25487 15.9499 7.46498C16.3337 6.67508 16.8921 5.98284 17.583 5.44063C16.7274 4.76822 15.6998 4.35008 14.6178 4.23401C13.5358 4.11795 12.443 4.30863 11.4642 4.78428C10.4855 5.25992 9.66027 6.00134 9.08294 6.92378C8.50562 7.84623 8.19946 8.91249 8.19946 10.0007C8.19946 11.0889 8.50562 12.1552 9.08294 13.0776C9.66027 14.0001 10.4855 14.7415 11.4642 15.2171C12.443 15.6928 13.5358 15.8835 14.6178 15.7674C15.6998 15.6513 16.7274 15.2332 17.583 14.5608C16.8919 14.0184 16.3334 13.3259 15.9496 12.5357C15.5658 11.7455 15.3668 10.8784 15.3678 9.9999V9.9999Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4132 13.5942V13.4073H26.4937V13.3687H26.302V13.4073H26.3777V13.5942H26.4132ZM26.7853 13.5942V13.3687H26.7273L26.6597 13.5298L26.592 13.3687H26.534V13.5942H26.5759V13.4234L26.6387 13.57H26.6822L26.745 13.4234V13.5942H26.7853Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9674 9.99998C26.9673 11.0883 26.6611 12.1546 26.0837 13.0771C25.5063 13.9996 24.6809 14.741 23.702 15.2165C22.7232 15.6921 21.6302 15.8827 20.5482 15.7664C19.4661 15.6502 18.4386 15.2319 17.583 14.5592C18.2735 14.0166 18.8318 13.3241 19.2157 12.5342C19.5996 11.7442 19.799 10.8774 19.799 9.99917C19.799 9.1209 19.5996 8.2541 19.2157 7.46416C18.8318 6.67423 18.2735 5.9818 17.583 5.4391C18.4386 4.76648 19.4661 4.34814 20.5482 4.23191C21.6302 4.11567 22.7232 4.30624 23.702 4.78181C24.6809 5.25739 25.5063 5.99879 26.0837 6.92127C26.6611 7.84374 26.9673 8.91007 26.9674 9.99837V9.99998Z",
    fill: "#F79E1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    stroke: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMc);
export default __webpack_public_path__ + "static/media/payment-mc.c6f900d0bc18101a3e1bf4b43d1ddf44.svg";
export { ForwardRef as ReactComponent };